<h2 mat-dialog-title>Thank you for joining Specsfin</h2>

<mat-dialog-content>
    <p>
        To complete the set-up of your practice, we require the practice owner’s or authorised representative’s signature to be saved on the system. 
    </p>

    <p>
        Please make sure that the signature pad that we have supplied you is plugged in and then proceed to the practice signature page.
    </p>

    <p>
        Thank you
    </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Close</button>
    <button mat-stroked-button color="primary" (click)="navigateToVendorSettings()">Take me there</button>
</mat-dialog-actions>